import EnhancedTab from 'lib/designSystem/TabSimulation';
import React from 'react';

import Templates from './Components/Templates';

const Contracts = () => {
  const tabs = [
    {
      label: 'Plantillas',
      component: <Templates />,
      path: 'templates',
    },
  ];
  return (
    <EnhancedTab
      tabType="secondary"
      startValue={0}
      tabs={tabs}
      onTabChange={() => {}}
    />
  );
};

export default Contracts;
